import { configure } from "@creditas/event-track";
import { getAppNameByPathname } from "./getAppNameByPathname";
import { getCurrentCustomer } from "../services";

export const identifyLeadForAnalyticEvents = async () => {
  const { fullName, cpf, email, contactCellphone, contactCellphoneCode } =
    await getCurrentCustomer();
  const appKeyName = getAppNameByPathname();
  const environment =
    process.env.NODE_ENV === "production" ? "production" : "staging";

  configure({
    application: `HOME_${appKeyName}`,
    bu: "HE",
    environment,
  }).identify({
    name: fullName,
    cpf: cpf,
    email: email,
    cellphone: `${contactCellphoneCode}${contactCellphone}`,
  });
};
